import { store } from '@store/index';
import { userApi } from '@services/api';
import { getAuthToken, hasAuthToken, setAuthCookies } from '@utils/cookie';
import { logout, setToken } from '@store/features/userSlice';

let pending: Promise<void> | null = null;

/** Shared by AppContent and the consultation retry button, including StrictMode remounts. */
export function ensureGuestIdentity(): Promise<void> {
  if (hasAuthToken()) return Promise.resolve();
  if (pending) return pending;
  const epoch = store.getState().user.authEpoch;
  pending = (async () => {
    const request = store.dispatch(userApi.endpoints.userGuest.initiate({ userAgent: navigator.userAgent }));
    try {
      const result = await request.unwrap();
      if (hasAuthToken() || store.getState().user.authEpoch !== epoch) return;
      if (!result.token) throw new Error('Guest initialization failed');
      setAuthCookies(result.token);
      store.dispatch(setToken(result.token));
    } finally { request.reset(); }
  })().finally(() => { pending = null; });
  return pending;
}

export function syncCookieIdentity(): void {
  const token = hasAuthToken() ? getAuthToken() : null;
  if (token === store.getState().user.token) return;
  store.dispatch(token ? setToken(token) : logout());
}
